var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBarChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.03125 7.80992L9.03125 50.3467H20.3045V7.80992H9.03125Z",
    fill: "#8CBFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3008 20.0629L20.3008 50.3433H31.574V20.0629H20.3008Z",
    fill: "#3B82C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5703 36.2328V50.3462H42.8435V36.2328H31.5703Z",
    fill: "#2B6299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.546875 0V50.7732H51.3201",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.3194,
    height: 51.3194,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartIcon);
export default __webpack_public_path__ + "static/media/bar_chart_icon.98c97b0a.svg";
export { ForwardRef as ReactComponent };